export const enNuggets = {
  title: "Nuggets",
  // The `generatePanel` block is gone with the panel itself: runs are started from
  // Data Hub > Domain > Nugget Configs, and its copy now lives under
  // `dataHub:domainDetail.nuggetConfig`. `rerun` stays -- NuggetRerunMenu still uses it.
  rerun: {
    buttonAria: "Re-run this run from a step",
    menuTitle: "Re-run from step",
    loading: "Loading steps…",
    loadError: "Could not load steps for this run.",
    startError: "Re-run failed: {{message}}",
    notResumable: "This run has no saved state before this step.",
    cachedHint: "Reuses saved query results",
    started: "Re-running from {{stage}}.",
  },
  subtitle: "AI-powered insights organized by priority and category",
  empty: "No nuggets found.",
  search: {
    placeholder: "Search nuggets...",
    noResults: "No nuggets found",
    noResultsHint: 'Try adjusting your search term: "{{query}}"',
  },
  filter: {
    ariaLabel: "Filter nuggets",
  },
  section: {
    newThisWeek: "New This Week",
    earlier: "Earlier",
    toggleAriaLabel: "Toggle {{title}} section",
  },
  list: {
    ariaLabel: "Nuggets",
  },
  card: {
    summaryLabel: "Summary:",
    moreActionsAriaLabel: "More actions",
    edit: "Edit",
    delete: "Delete",
  },
  // Top-level rather than nested under card/modal: the dot and the dropdown both render these, and
  // neither should have to know which surface is hosting it.
  severity: {
    high: "High",
    medium: "Medium",
    low: "Low",
    placeholder: "Set severity",
    selectAriaLabel: "Nugget severity",
  },
  feedback: {
    thumbUpAriaLabel: "Mark this nugget as helpful",
    thumbDownAriaLabel: "Mark this nugget as not helpful",
    thumbUpTooltip: "Helpful",
    thumbDownTooltip: "Not helpful",
    commentHeadingUp: "What made this useful?",
    commentHeadingDown: "What missed the mark?",
    commentSubheading: "Optional — your feedback is already saved.",
    commentPlaceholderUp: "e.g. spotted a trend we hadn't noticed",
    commentPlaceholderDown: "e.g. the revenue number looks wrong",
    commentAriaLabel: "Additional feedback about this nugget",
    commentError: "Could not save your comment. Please try again.",
    skip: "Skip",
    submit: "Submit",
  },
  deleteDialog: {
    heading: "Delete nugget",
    subheading: "This nugget will be permanently deleted and cannot be recovered.",
    cancel: "Cancel",
    confirm: "Delete",
  },
  modal: {
    closeAriaLabel: "Close nugget details",
    summaryLabel: "Summary:",
    lensLabel: "Lens",
    focusAreaLabel: "Focus Area",
    timeframeSummaryLabel: "Timeframe",
    documentPreviewsTitle: "Cited document pages",
    documentPreviewCollapse: "Collapse page",
    explore: "Explore",
    backAriaLabel: "Back to details",
    takeAction: "Take Action",
    takingAction: "Taking action…",
    takeActionError: "Could not take this action. Please try again.",
    recommendedActionTitle: "{{actionType}} via {{integrationType}}",
    recommendedActionManualTitle: "Suggested next step",
    sections: {
      insights: "Insights:",
      why: "Why:",
      recommendedActions: "Recommended Actions:",
      businessImpact: "Business Impact:",
      howGenerated: "How it was generated:",
      context: "Context:",
    },
    edit: {
      titleLabel: "Title",
      summaryLabel: "Summary",
      followUpQuestionsLabel: "Follow-up Questions",
      itemTitleLabel: "Item title",
      itemDescriptionLabel: "Item description",
      addRow: "Add",
      removeRowAriaLabel: "Remove",
      cancel: "Cancel",
      save: "Save",
      saving: "Saving…",
      titleRequired: "Title is required.",
      summaryRequired: "Summary is required.",
      saveError: "Could not save this nugget. Please try again.",
    },
  },
  exploreView: {
    suggestedChats: "Suggested Chats:",
    suggestedApps: "Suggested Apps:",
    noQuestions: "No follow-up questions available.",
    noApps: "No related apps available.",
  },
} as const;
